import type { ButtonHTMLAttributes } from "react";

function TrashIcon() {
  return (
    <svg
      viewBox="0 0 16 16"
      width="15"
      height="15"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.35"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M3.5 4.5h9M6 4.5V3.25h4V4.5M5 6.5l.4 6h5.2l.4-6M7 7v3.5M9 7v3.5" />
    </svg>
  );
}

export function TrashButton({
  label,
  ...props
}: Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children" | "aria-label"> & {
  label: string;
}) {
  return (
    <button
      {...props}
      type="button"
      className="ui-trash-action"
      aria-label={label}
      title={label}
    >
      <TrashIcon />
    </button>
  );
}
